export default "__VITE_PUBLIC_ASSET__35f9d3bd__"